import { useQuery } from '@tanstack/react-query';
import { useGetWeighingNoteBillingStatusApi } from './monolith';
import { GetWeighingNoteBillingStatusParams } from './types/WeighingNoteBilling';

export const useGetWeighingNoteBillingStatus = (params: GetWeighingNoteBillingStatusParams) => {
    const { getWeighingNoteBillingStatus } = useGetWeighingNoteBillingStatusApi();
    return useQuery({
        queryKey: ['weighingNoteBillingStatus', params],
        queryFn: () => getWeighingNoteBillingStatus(params),
        refetchOnWindowFocus: false,
    });
};
